import React, { Component } from "react";
import { connect } from "react-redux";
import { Table } from "semantic-ui-react";
import CountUp from "react-countup";
import languages from "../languages.json";

export default connect(mapStateToProps)(
    class Results extends Component {
        render() {
            const tco =
                this.props.tco.vehicle_tco + this.props.tco.company_tco + this.props.tco.financial_rent;
            const initial_tco =
                this.props.initial_tco.initial_vehicle_tco +
                this.props.initial_tco.initial_company_tco +
                this.props.initial_tco.initial_financial_rent;
            const t = languages[this.props.language];

            return (
                <Table textAlign="center" verticalAlign="middle" compact="very">
                    <Table.Body>
                        <Table.Row active>
                            <Table.HeaderCell>
                                <p style={{ marginBottom: 0 }}>
                                    <strong>
                                        {t.stats.tco_simulation}
                                        {this.props.language === "en-gb" ?  ": " : " : "}
                                        <CountUp
                                            start={300}
                                            end={tco}
                                            duration={0.5}
                                            useEasing={true}
                                            separator={this.props.language === "en-gb" ?  "," : " "}
                                            prefix={" "}
                                            suffix={" " + t.parameters.money}
                                            redraw={true}
                                        />
                                    </strong>
                                </p>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <p style={{ marginBottom: 0 }}>
                                    <strong>
                                        {t.stats.tco_reference}
                                        {this.props.language === "en-gb" ?  ": " : " : "}
                                        <CountUp
                                            start={300}
                                            end={initial_tco}
                                            duration={0.5}
                                            useEasing={true}
                                            separator={this.props.language === "en-gb" ?  "," : " "}
                                            prefix={" "}
                                            suffix={" " + t.parameters.money}
                                            redraw={true}
                                        />
                                    </strong>
                                </p>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell colSpan={2}>
                                <p style={{ marginBottom: 0 }}>
                                    <strong>
                                        {t.stats.delta}{this.props.language === "en-gb" ?  ": " : " : "}
                                    </strong>
                                </p>
                                <p style={{ marginBottom: 0 }}>
                                    <strong>
                                        <CountUp
                                            start={300}
                                            end={tco - initial_tco}
                                            duration={0.5}
                                            useEasing={true}
                                            separator=","
                                            prefix={tco > initial_tco ? " + " : " "}
                                            suffix={" " + t.parameters.money}
                                            redraw={true}
                                        />
                                        {" "}
                                        (<CountUp
                                            start={300}
                                            end={Math.round(((tco - initial_tco) / initial_tco) * 100)}
                                            duration={0.5}
                                            useEasing={true}
                                            separator={this.props.language === "en-gb" ?  "," : " "}
                                            prefix={tco >= initial_tco ? " + " : " "}
                                            suffix={" %"}
                                            redraw={true}
                                        />)
                                    </strong>
                                </p>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        tco: state.reducerTco,
        initial_tco: state.reducerInitialTco,
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/results.js